<script setup lang="ts">
import { computed, ref } from 'vue'
import { Info, Monitor, Moon, PanelsTopLeft, Rows3, Search, Sun } from 'lucide-vue-next'
import { APP_TITLE } from '@/constants/app'
import AboutDialog from '@/components/layout/AboutDialog.vue'
import { useTheme } from '@/composables/useTheme'

const aboutOpen = ref(false)
const { mode, cycle } = useTheme()

const themeIcon = computed(() => (mode.value === 'light' ? Sun : mode.value === 'dark' ? Moon : Monitor))
const themeLabel = computed(() =>
  mode.value === 'light' ? 'ライト' : mode.value === 'dark' ? 'ダーク' : '自動'
)
</script>

<template>
  <header class="bg-surface border-b border-border px-4 flex items-center gap-2 h-12 shrink-0">
    <div class="flex min-w-0 items-center gap-2">
      <img src="/favicon-192.png" alt="" aria-hidden="true" class="block size-5 shrink-0 rounded-sm" />
      <h1 class="min-w-0 -translate-y-px truncate text-base font-bold leading-none text-text">{{ APP_TITLE }}</h1>
    </div>
    <nav class="ml-2 hidden items-center gap-1 sm:flex">
      <RouterLink
        to="/"
        class="inline-flex items-center gap-1.5 rounded px-2 py-1 text-sm text-text-muted transition-colors hover:bg-overlay hover:text-text"
        exact-active-class="bg-overlay text-text"
      >
        <Search :size="15" />
        <span>カード検索</span>
      </RouterLink>
      <RouterLink
        to="/tiers"
        class="inline-flex items-center gap-1.5 rounded px-2 py-1 text-sm text-text-muted transition-colors hover:bg-overlay hover:text-text"
        exact-active-class="bg-overlay text-text"
      >
        <Rows3 :size="15" />
        <span>ティア表</span>
      </RouterLink>
      <RouterLink
        to="/boards"
        class="inline-flex items-center gap-1.5 rounded px-2 py-1 text-sm text-text-muted transition-colors hover:bg-overlay hover:text-text"
        exact-active-class="bg-overlay text-text"
      >
        <PanelsTopLeft :size="15" />
        <span>盤面</span>
      </RouterLink>
    </nav>
    <div class="ml-auto flex items-center gap-4 shrink-0">
      <RouterLink
        to="/"
        class="grid size-8 place-items-center rounded text-text-muted transition-colors hover:bg-overlay hover:text-text sm:hidden"
        exact-active-class="bg-overlay text-text"
        v-tooltip="'カード検索'"
      >
        <Search :size="16" />
      </RouterLink>
      <RouterLink
        to="/tiers"
        class="grid size-8 place-items-center rounded text-text-muted transition-colors hover:bg-overlay hover:text-text sm:hidden"
        exact-active-class="bg-overlay text-text"
        v-tooltip="'ティア表'"
      >
        <Rows3 :size="16" />
      </RouterLink>
      <RouterLink
        to="/boards"
        class="grid size-8 place-items-center rounded text-text-muted transition-colors hover:bg-overlay hover:text-text sm:hidden"
        exact-active-class="bg-overlay text-text"
        v-tooltip="'盤面'"
      >
        <PanelsTopLeft :size="16" />
      </RouterLink>
      <button
        type="button"
        class="flex items-center gap-1.5 text-sm text-muted hover:text-text transition-colors"
        v-tooltip="`テーマ: ${themeLabel}（クリックで切替）`"
        @click="cycle"
      >
        <component :is="themeIcon" :size="16" />
      </button>
      <button
        type="button"
        class="flex items-center gap-1.5 text-sm text-muted hover:text-text transition-colors"
        v-tooltip="'サイトについて'"
        @click="aboutOpen = true"
      >
        <Info :size="16" />
        <span class="hidden sm:inline">サイトについて</span>
      </button>
    </div>
    <AboutDialog v-model:open="aboutOpen" />
  </header>
</template>
